/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliveryAddressCheckRequestSchema } from "./deliveryAddressCheckRequestSchema.ts";
import { deliveryAddressCheckResponseSchema } from "./deliveryAddressCheckResponseSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";

export const orgUnitDeliveryCheckAddressCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitDeliveryCheckAddressCreateStatus200Schema = deliveryAddressCheckResponseSchema;

export const orgUnitDeliveryCheckAddressCreateStatus400Schema = errorResponseSchema;

export const orgUnitDeliveryCheckAddressCreateResponseSchema = z.union([
	orgUnitDeliveryCheckAddressCreateStatus200Schema,
	orgUnitDeliveryCheckAddressCreateStatus400Schema,
]);

export const orgUnitDeliveryCheckAddressCreateDataSchemaJson = deliveryAddressCheckRequestSchema.optional();

export const orgUnitDeliveryCheckAddressCreateDataSchemaXml = deliveryAddressCheckRequestSchema.optional();

export const orgUnitDeliveryCheckAddressCreateDataSchema = z.union([
	orgUnitDeliveryCheckAddressCreateDataSchemaJson,
	orgUnitDeliveryCheckAddressCreateDataSchemaXml,
]);
